import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import PropTypes from 'prop-types';
import { isNullOrUndefined } from "../../../utils/fn";
import { withState } from "../enhancers";
import MaskedInput from "./MaskedInput";
var valueToInt = function valueToInt(value) {
  return value === '' ? null : parseInt(value, 10);
};

/**
 * Input with mask to render number via 3-digit groups
 */
var PriceInput = /*#__PURE__*/function (_React$Component) {
  _inherits(PriceInput, _React$Component);
  var _super = _createSuper(PriceInput);
  function PriceInput() {
    var _this;
    _classCallCheck(this, PriceInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    /**
     * we use mask dynamically, based on number of symbols
     */
    _defineProperty(_assertThisInitialized(_this), "getMask", function (nextValue) {
      return nextValue.split('').map(function (_, index) {
        return index % 3 === 0 && index !== 0 ? '_ ' : '_';
      }).reverse().join('');
    });
    _defineProperty(_assertThisInitialized(_this), "getValueString", function () {
      var value = _this.props.value;
      return !isNullOrUndefined(value) ? value.toString() : '';
    });
    /**
     * Remove all non digits and slice by maxLength
     */
    _defineProperty(_assertThisInitialized(_this), "unmaskNumber", function (maskedValue) {
      var maxLength = _this.props.maxLength;
      var value = maskedValue.replace(/\D/g, '');
      if (maxLength) value = value.substring(0, maxLength);
      return value;
    });
    /**
     * onChange should return integer value
     */
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, event) {
      var onChange = _this.props.onChange;
      if (onChange) onChange(valueToInt(value), event);
    });
    /**
     * we have to override onFocus and onBlur,
     * normally they fire with event as first argument,
     * we add value as second
     */
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function (value, event) {
      var onFocus = _this.props.onFocus;
      if (onFocus) onFocus(valueToInt(value), event);
    });
    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (value, event) {
      var onBlur = _this.props.onBlur;
      if (onBlur) onBlur(valueToInt(value), event);
    });
    return _this;
  }
  _createClass(PriceInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(MaskedInput, _extends({}, this.props, {
        /** maxLength is processed in `unmask` above */
        inputMode: "numeric",
        mask: this.getMask,
        maxLength: null,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        pattern: "[0-9]*",
        unmaskValue: this.unmaskNumber,
        value: this.getValueString()
      }));
    }
  }]);
  return PriceInput;
}(React.Component);
export { PriceInput as default };
PriceInput.propTypes = process.env.NODE_ENV !== "production" ? {
  maxLength: PropTypes.number,
  // controls max number of digits allowed to enter

  /** inherited from withError */
  status: PropTypes.oneOf(['fail']),
  error: PropTypes.string,
  keepErrorIndent: PropTypes.bool,
  /** inherited from withIcon */
  Icon: PropTypes.func,
  iconAlt: PropTypes.string,
  isClearable: PropTypes.bool,
  onIconClick: PropTypes.func,
  onClear: PropTypes.func,
  /** inherited from withMask */
  // mask: No longer available,
  // unmaskValue: No longer available,

  /**
   * some notable default input props are listed here
   * all the other props are simply passed down
   */
  size: PropTypes.oneOf(['big']),
  // type: No longer available
  value: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  className: PropTypes.string
} : {};
PriceInput.defaultProps = {
  maxLength: 7,
  isClearable: false
};

/**
 * stateful version accepts all the same propTypes,
 * except for `value`
 */
export var StatefulPriceInput = withState(PriceInput);
StatefulPriceInput.defaultProps = {
  value: null
};